export enum IPreviewTabId {
    Detail = "detail",
    List = "list",
}

export interface IPreviewProps {
    details?: () => Promise<string>
    list?: () => Promise<string>
}
